import Vue from "vue";
import Router from "vue-router";
import TextFolderDetails from "../views/textFolderDetails.vue";
import Profile from "../views/profile.vue";
import TextFolders from "../views/textFolders.vue";
import AboutUs from "../views/about.vue";
import Help from "../views/help.vue";
import Landing from "../views/landing.vue";
import Service from "../views/service.vue";
import Start from "../views/start.vue";
import Privacy from "../views/privacy.vue";
import Test from "../views/test.vue";
import NotFound from "../views/notFoundPage.vue";
import PaymentHistory from "../views/paymentHistory.vue";
import Orders from "../views/orders.vue";
import Plan from "../views/plan.vue";
import FileFolderDetails from "../views/fileFolderDetails.vue";
import FileFolders from "../views/fileFolders.vue";
import BuyPage from "../views/pricePage.vue";
import MobilePlanPage from "../views/mobilePlan.vue";
import MobileOrderPage from "../views/mobileOrder.vue";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    { path: "/", name: "default" },
    {
      path: "/home",
      name: "landing",
      title: "Чимэгэ уншигч",
      component: Landing,
    },
    {
      path: "/about",
      name: "about",
      component: AboutUs,
    },
    {
      path: "/plan",
      name: "plan",
      component: Plan,
    },
    {
      path: "/payment/:token",
      name: "payment",
      component: Plan,
      meta: { requiresAuth: true },
    },
    {
      path: "/help",
      name: "help",
      component: Help,
    },
    {
      path: "/service",
      name: "service",
      component: Service,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
    },
    {
      path: "/test",
      name: "test",
      component: Test,
    },
    //
    {
      path: "/projects",
      name: "projects",
      component: TextFolders,
      meta: { requiresAuth: true },
    },
    // {
    //   path: "/books",
    //   name: "books",
    //   component: FileFolders,
    //   meta: { requiresAuth: true },
    // },
    {
      path: "/books",
      name: "books",
      component: FileFolders,
      meta: { requiresAuth: true },
    },
    {
      path: "/start",
      name: "start",
      component: Start,
      meta: { requiresAuth: true },
    },
    {
      path: "/history",
      name: "history",
      component: PaymentHistory,
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: "/project/:folderId",
      name: "textFolderDetails",
      component: TextFolderDetails,
      meta: { requiresAuth: true },
    },
    // {
    //   path: "/book/:folderId",
    //   name: "fileFolderDetails",
    //   component: FileFolderDetails,
    //   meta: { requiresAuth: true },
    // },
    {
      path: "/book/:folderId",
      name: "fileFolderDetails",
      component: FileFolderDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "*",
      name: "notFound",
      component: NotFound,
    },
    {
      path: "/app/buy",
      name: "app",
      component: BuyPage,
    },
    {
      path: "/app/plan",
      name: "app",
      component: MobilePlanPage,
    },
    {
      path: "/app/orders",
      name: "app",
      component: MobileOrderPage,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.query.t) {
    console.log(to);
    Vue.cookie.set("token", to.query.t);
    next("/start");
  }
  var token = Vue.cookie.get("token");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.name == "payment") {
      Vue.cookie.set("token", to.params.token);
      next();
    } else if (token) {
      next();
    } else {
      window.location.href = process.env.VUE_APP_BASE_URL + "/login";
    }
  } else {
    if (token && to.path == "/") {
      next("/start");
    } else if (to.path == "/") {
      next("/home");
    } else {
      next();
    }
  }
});
export default router;
